import { useTranslations } from "@jugl-web/utils";
import React from "react";

export const EmptyInfoElement: React.FC = () => {
  const { t } = useTranslations();

  return (
    <span className="text-grey-800 font-secondary mt-1 text-[13px] leading-[140%]">
      {t({
        id: "chats-page.no-info-added",
        defaultMessage: "No Info added",
      })}
    </span>
  );
};
